import React from 'react';
import { Facebook, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)', padding: '80px 0 40px' }}>
      <div className="luxury-container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '48px', marginBottom: '60px' }}>
          <div>
            <h3 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: 'var(--accent-gold)' }}>Enliven</span> Elite Tax Pro
            </h3>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: 'var(--border-light)', marginBottom: '16px' }}>
              Elite Service. Exceptional Accuracy.
            </p>
            <p style={{ fontSize: '12px', lineHeight: '1.6', color: 'var(--text-light)' }}>
              Professional tax preparation services for individuals, self-employed professionals, and small businesses.
            </p>
          </div>

          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px' }}>Contact Information</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a
                href="tel:800-426-0441"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  color: 'var(--border-light)',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--border-light)'}
              >
                <Phone size={16} />
                800-426-0441
              </a>
              <a
                href="mailto:taxprep@enlivenelite.tax"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  color: 'var(--border-light)',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--border-light)'}
              >
                <Mail size={16} />
                taxprep@enlivenelite.tax
              </a>
            </div>
          </div>

          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px' }}>Follow Us</h4>
            <a
              href="https://www.facebook.com/share/1acsUdJzHi/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 20px',
                border: '1px solid var(--border-light)',
                borderRadius: '0px',
                color: 'var(--border-light)',
                textDecoration: 'none',
                fontSize: '14px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'var(--bg-primary)';
                e.currentTarget.style.color = 'var(--text-primary)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'var(--border-light)';
              }}
            >
              <Facebook size={16} />
              Follow on Facebook
            </a>
          </div>
        </div>

        <div style={{ paddingTop: '40px', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <p style={{ fontSize: '12px', color: 'var(--text-light)' }}>
              © {currentYear} Enliven Elite Tax Pro. All rights reserved.
            </p>
            <div style={{ display: 'flex', gap: '24px' }}>
              <Link
                to="/privacy"
                style={{
                  fontSize: '12px',
                  color: 'var(--text-light)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-light)'}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                style={{
                  fontSize: '12px',
                  color: 'var(--text-light)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                onMouseLeave={(e) => e.target.style.color = 'var(--text-light)'}
              >
                Terms of Service
              </Link>
            </div>
          </div>
          <p style={{ fontSize: '11px', color: 'var(--text-light)', marginTop: '16px', fontStyle: 'italic' }}>
            Professional tax preparation services. Not affiliated with the IRS.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;